import { SearchResults } from '../../../services/search/getSearchResults';

export const WARN_ONE_ACCURATE_WITH_ONE_OTHER = 'Potrebbe interessarti anche il seguente immobile:';
export const WARN_ONE_ACCURATE_WITH_MORE_OTHER = 'Potrebbero interessarti anche i seguenti immobili:';
export const WARN_ZERO_ACCURATE_WITH_ONE_OTHER = 'Non abbiamo trovato immobili in linea con la tua ricerca. Potrebbe interessarti:';
export const WARN_ZERO_ACCURATE_WITH_MORE_OTHER = 'Non abbiamo trovato immobili in linea con la tua ricerca. Potrebbero interessarti:';
export const WARN_NO_RESULTS = 'Non abbiamo trovato immobili in linea con la tua ricerca.';

export function getWarningMessage(searchResults: SearchResults): string | undefined {
  const { accurate, nearby, similar } = searchResults;
  const others = nearby || similar;
  const othersCount = others?.numberOfElements ?? 0;

  if (accurate.numberOfElements > 1) {
    return undefined;
  }

  if (accurate.numberOfElements === 1) {
    if (othersCount === 0) {
      return undefined;
    }

    return othersCount === 1
      ? WARN_ONE_ACCURATE_WITH_ONE_OTHER
      : WARN_ONE_ACCURATE_WITH_MORE_OTHER;
  }

  // accurate.numberOfElements === 0
  if (othersCount === 0) {
    return WARN_NO_RESULTS;
  }

  return othersCount === 1
    ? WARN_ZERO_ACCURATE_WITH_ONE_OTHER
    : WARN_ZERO_ACCURATE_WITH_MORE_OTHER;
}
